/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const chevronLeftSmall = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="m13.1 16-3.4-4 3.4-4 1.1 1-2.6 3 2.6 3-1.1 1z" />
	</SVG>
);

export default chevronLeftSmall;
